import { Button } from "@aidron/aidron-ds";

import PropTypes from "prop-types";
import { ORDERING_MODES } from "../../../../components/components.constants";

export function MonthSortByButton({ actions, ctx, uiState }) {
  const { setSortRowsBy = () => {} } = actions || {};
  const { monthObj } = ctx || {};
  const { column, sortRowsBy } = uiState || {};

  const isAlreadySortedByThisColumn = (newSortBy) => {
    if (!sortRowsBy.columnLabel || !sortRowsBy.months) return false;

    return (
      sortRowsBy.columnLabel === newSortBy.columnLabel &&
      sortRowsBy.months[0] === newSortBy.months[0] &&
      sortRowsBy.year === newSortBy.year
    );
  };

  const updateSortBy = () => {

    const newSortBy = {
      orderForecastId: monthObj.forecastId || undefined,
      columnLabel: column.name || undefined,
      months: monthObj.months,
      year: monthObj.year,
      ...(column.indexOne !== undefined && { indexOne: column.indexOne }),
      ...(column.indexTwo !== undefined && { indexTwo: column.indexTwo }),
    };

    if (isAlreadySortedByThisColumn(newSortBy)) {
      const newOrder =
        sortRowsBy.order === ORDERING_MODES.ASCENDING ? ORDERING_MODES.DESCENDING : ORDERING_MODES.ASCENDING;
      setSortRowsBy({ ...sortRowsBy, order: newOrder });
    } else {
      setSortRowsBy({
        ...newSortBy,
        order:
          newSortBy.columnLabel.substring(0, 7) === "percent"
            ? ORDERING_MODES.ASCENDING
            : ORDERING_MODES.DESCENDING,
      });
    }
  };

  const determineColumnIcon = (columnLabel, monthObj) => {
    if (
      sortRowsBy?.columnLabel === columnLabel &&
      sortRowsBy?.months &&
      sortRowsBy?.months[0] === monthObj.months[0] &&
      sortRowsBy?.year === monthObj.year
    ) {
      return sortRowsBy?.order === ORDERING_MODES.ASCENDING ? "arrow-down" : "arrow-up";
    } else return "chevron-down";
  };

  return (
    <Button
      label=""
      onClick={updateSortBy}
      type="ghost"
      icon={determineColumnIcon(column.name, monthObj)}
      className="ms-1"
    />
  );
}

MonthSortByButton.propTypes = {
  actions: PropTypes.shape(),
  uiState: PropTypes.shape(),
  ctx: PropTypes.shape(),
};